import createAccordion from '../anims/Accordion'

export default class Accordions {
  constructor() {
    this._getElems()
    this._accordions()
  }

  _getElems() {
    this.accordions = Array.from(document.querySelectorAll('.accordion'))
    .filter((el) => !el.classList.contains('--empty-content'))
    .map((el) => ({
      el,
      header: el.querySelector('.accordion__header'),
      content: el.querySelector('.accordion__content'),
      contentPadding: el.dataset.contentPadding ?? 24
    }))
  }

  _accordions() {
    if (this.accordions) {
      this.accordions.forEach((accordion) => {
        createAccordion(accordion)
      })
    }
  }
}
